import React from "react";
import { Button, Modal } from "react-bootstrap";
import { IGame, IUser } from "../types/api";
import { defaultDateTimeFormat } from "../lib/utils";

interface ModalProps {
    show: boolean;
    action: string;
    game: IGame;
    handleClose: (key: string) => void;
    handleAction: (action: string, gameId: IGame["id"]) => void;
}

const gameBody = (game: IGame, action: string) => {
    return (
        <>
            <h5>Are you sure you want to {action} this game?</h5>
            <ul style={{ listStyleType: "none" }}>
                <li>
                    <b>Game Date: </b>{" "}
                    {defaultDateTimeFormat.format(new Date(game.date))}
                </li>
                <li>
                    <b>Home: </b>
                    {game.home.name}
                </li>
                <li>
                    <b>Visitor: </b>
                    {game.visitor.name}
                </li>
                <li>
                    <b>Location: </b>
                    {game.fieldName}
                </li>
                {game.diamond && (
                    <>
                        <b>Diamond: </b>
                        {game.diamond}
                    </>
                )}
            </ul>
        </>
    );
};

const GameActionModal = ({
    show,
    action,
    game,
    handleClose,
    handleAction,
}: ModalProps) => {
    const buildModalBody = () => {
        switch (action) {
            case "delete":
            case "postpone":
                return gameBody(game, action);
        }
    };

    return (
        <Modal show={show} onHide={() => handleClose(action)}>
            <Modal.Header>
                <Modal.Title>{`${
                    action.charAt(0).toUpperCase() + action.slice(1)
                } Game`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{buildModalBody()}</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => handleClose(action)}>
                    No
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        handleAction(action, game.id);
                    }}
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GameActionModal;
